module.exports = __webpack_public_path__ + "img/image (6).34268ff8.webp";